var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-popup',{attrs:{"opened":_vm.opened}},[_c('f7-page',[_c('dark-popup-navigation-bar',{on:{"close":function($event){return _vm.$emit('close')}}}),_c('background',[_c('video-view',{attrs:{"video-url":_vm.videoUrl}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }